import ApiService from '@/api/http/ApiService';
import axios, { AxiosPromise } from 'axios';
import { LightspeedSyncMode } from '@/enums/LightspeedSyncMode';
import { Staff } from '@/interfaces/models/Staff';

export default class LightspeedApiService extends ApiService<any> {
  constructor() {
    super('lightspeed');
  }

  public syncFoodcard(payload: { venue: string; mode: LightspeedSyncMode }): AxiosPromise<void> {
    return axios.post(`${this.getBaseUrl()}/foodcard/sync`, payload);
  }

  public syncTables(payload: { venue: string }): AxiosPromise<void> {
    return axios.post(`${this.getBaseUrl()}/tables/sync`, payload);
  }

  public getStaff(venueId: string): AxiosPromise<Staff[]> {
    return axios.get(`${this.getBaseUrl()}/users/${venueId}`);
  }
}
